<app-navbar></app-navbar>

<div class="payment-pending-container">
  <div class="result-card">
    <!-- Loading State -->
    @if (isLoading) {
      <div class="loading-state">
        <div class="spinner"></div>
        <h2>Verificando el estado de tu pago...</h2>
        <p>Por favor espera mientras confirmamos tu transacción.</p>
      </div>
    }

    <!-- Error State -->
    @if (error && !isLoading) {
      <div class="error-state">
        <div class="icon-container error">
          <i class="fas fa-exclamation-triangle"></i>
        </div>
        <h2>Problema con la verificación</h2>
        <p class="error-message">{{ error }}</p>
        
        <div class="action-buttons">
          <button class="btn btn-primary" (click)="goToReservations()">
            <i class="fas fa-list"></i>
            Ver Mis Reservas
          </button>
          <button class="btn btn-secondary" (click)="goToHome()">
            <i class="fas fa-home"></i>
            Ir a Inicio
          </button>
        </div>
      </div>
    }

    <!-- Pending State -->
    @if (paymentDetails && !error && !isLoading) {
      <div class="pending-state">
        <div class="icon-container pending">
          <i class="fas fa-clock"></i>
        </div>
        
        <h2>Pago en Proceso</h2>
        <p class="pending-message">Tu pago está siendo procesado. Te notificaremos cuando esté confirmado.</p>

        <div class="payment-details">
          <h3>Detalles del Pago</h3>
          <div class="detail-row">
            <span class="label">ID de Reserva:</span>
            <span class="value">{{ reservation_id }}</span>
          </div>
          @if (payment_id) {
            <div class="detail-row">
              <span class="label">ID de Pago:</span>
              <span class="value">{{ payment_id }}</span>
            </div>
          }
          @if (paymentDetails.payment?.status) {
            <div class="detail-row">
              <span class="label">Estado:</span>
              <span class="value status pending">{{ paymentDetails.payment.status }}</span>
            </div>
          }
          @if (paymentDetails.payment?.status_description) {
            <div class="detail-row">
              <span class="label">Descripción:</span>
              <span class="value">{{ paymentDetails.payment.status_description }}</span>
            </div>
          }
        </div>

        <div class="processing-info">
          <h3>¿Por qué está pendiente?</h3>
          <ul class="info-list">
            <li><i class="fas fa-university"></i> Tu banco está verificando la transacción</li>
            <li><i class="fas fa-shield-alt"></i> Proceso de validación de seguridad en curso</li>
            <li><i class="fas fa-hourglass-half"></i> Los pagos pueden tardar entre 1-3 días hábiles</li>
            <li><i class="fas fa-mobile-alt"></i> Es posible que necesites confirmar en tu app bancaria</li>
          </ul>
        </div>

        <div class="next-steps">
          <h3>¿Qué Sucede Ahora?</h3>
          <ul>
            <li><i class="fas fa-bell"></i> Te notificaremos por email cuando se confirme el pago</li>
            <li><i class="fas fa-calendar-check"></i> Tu reserva queda temporalmente apartada</li>
            <li><i class="fas fa-sync-alt"></i> Puedes verificar el estado desde tu dashboard</li>
            <li><i class="fas fa-headset"></i> Si tienes dudas, puedes contactar nuestro soporte</li>
          </ul>
        </div>

        <div class="action-buttons">
          <button class="btn btn-primary" (click)="checkStatus()">
            <i class="fas fa-sync-alt"></i>
            Verificar Estado
          </button>
          <button class="btn btn-secondary" (click)="goToReservations()">
            <i class="fas fa-list"></i>
            Mis Reservas
          </button>
          <button class="btn btn-tertiary" (click)="goToHome()">
            <i class="fas fa-home"></i>
            Ir a Inicio
          </button>
        </div>

        <div class="patience-notice">
          <i class="fas fa-info-circle"></i>
          <div>
            <p><strong>¡Ten paciencia!</strong></p>
            <p>Los pagos pendientes suelen resolverse automáticamente. Te mantendremos informado del progreso.</p>
          </div>
        </div>
      </div>
    }
  </div>
</div>

<app-footer></app-footer>
